import {
  LOAD_OFFICE_LOCATIONS,
  LOAD_PAYMENT_TERMS,
  LOAD_TRANSPORT_METHODS,
  OFFICE_LOCATIONS_FAILED,
  OFFICE_LOCATIONS_LOADED,
  PAYMENT_TERMS_FAILED,
  PAYMENT_TERMS_LOADED,
  RESET_METADATA,
  RESET_PAYMENT_TERMS,
  TRANSPORT_METHODS_FAILED,
  TRANSPORT_METHODS_LOADED,
} from './actionTypes';
import transportMethods from './mocks/transportMethods.json';
import type { IMetadataState } from './types';

export const initialState = {
  officeLocations: [],
  officeLocationsLoadedProductType: '',
  officeLocationsLoading: false,
  officeLocationsError: null,

  paymentTerms: [],
  paymentTermsLoadedProductType: '',
  paymentTermsLoading: false,
  paymentTermsError: null,

  transportMethods: transportMethods,
  transportMethodsLoaded: false,
  transportMethodsLoading: false,
  transportMethodsError: null,
};

export const reducer = (
  state: IMetadataState = initialState,
  action: { type: any; payload?: any },
): IMetadataState => {
  switch (action.type) {
    case LOAD_OFFICE_LOCATIONS:
      return {
        ...state,
        officeLocationsError: null,
        officeLocations: [],
        officeLocationsLoading: true,
        officeLocationsLoadedProductType: '',
      };
    case OFFICE_LOCATIONS_LOADED:
      return {
        ...state,
        officeLocationsError: null,
        officeLocations: action.payload.data,
        officeLocationsLoading: false,
        officeLocationsLoadedProductType: action.payload.productType,
      };
    case OFFICE_LOCATIONS_FAILED:
      return { ...state, officeLocationsLoading: false, officeLocationsError: action.payload };

    case LOAD_PAYMENT_TERMS:
      return {
        ...state,
        paymentTermsError: null,
        paymentTermsLoading: true,
        paymentTermsLoadedProductType: '',
      };
    case RESET_PAYMENT_TERMS:
      return {
        ...state,
        paymentTermsLoadedProductType: '',
        paymentTermsLoading: false,
        paymentTermsError: null,
      };
    case PAYMENT_TERMS_LOADED:
      return {
        ...state,
        paymentTermsError: null,
        paymentTerms: action.payload.data,
        paymentTermsLoading: false,
        paymentTermsLoadedProductType: action.payload.productType,
      };
    case PAYMENT_TERMS_FAILED:
      return { ...state, paymentTermsLoading: false, paymentTermsError: action.payload };

    case LOAD_TRANSPORT_METHODS:
      return { ...state, transportMethodsError: null, transportMethodsLoading: true };
    case TRANSPORT_METHODS_LOADED:
      return {
        ...state,
        transportMethodsError: null,
        transportMethods: action.payload,
        transportMethodsLoading: false,
        transportMethodsLoaded: true,
      };
    case TRANSPORT_METHODS_FAILED:
      return { ...state, transportMethodsLoading: false, transportMethodsError: action.payload };

    case RESET_METADATA:
      return initialState;
    default:
      return state;
  }
};
